// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3BZGc","actionsCol":"EnrolledClinics_actionsCol__3Ptkb"};